// Add/remove extra inlet-connection Aux columns (Aux 4, 5, …) across all the
// Coupling Inlet Connections tables at once. Built-in columns are Aux 1-3; the
// extra ones' values overflow to custiteminlet_connection_notes on submit.

import { useAnswers } from "../state/AnswersContext";

const BUILTIN_AUX = 3;

export default function AuxColumnControl() {
  const { extraAuxColumns, setExtraAuxColumns, setAnswer } = useAnswers();
  const highest = BUILTIN_AUX + extraAuxColumns;

  const addAux = () => {
    // Seed the new connection's size to "None" (like Aux 1-3), so the dependent
    // tables (Orientation/UP/Position/Insert) start locked and only open up once
    // a real size is chosen — matching the built-in Aux behavior.
    const newN = highest + 1;
    setAnswer("SIZE_TABLE", `AUX_${newN}_1`, "None");
    setExtraAuxColumns(extraAuxColumns + 1);
  };

  return (
    <div className="cpq-aux-control">
      <span className="cpq-aux-control-label">Inlet Aux columns: Aux 1–{highest}</span>
      <button
        type="button"
        className="cpq-btn cpq-aux-add"
        onClick={addAux}
        title="Add another Aux connection column to every inlet table"
      >
        + Add Aux {highest + 1}
      </button>
      <button
        type="button"
        className="cpq-btn"
        onClick={() => setExtraAuxColumns(extraAuxColumns - 1)}
        disabled={extraAuxColumns === 0}
        title="Remove the last added Aux column"
      >
        − Remove Aux {highest}
      </button>
    </div>
  );
}
